export default "__VITE_ASSET__C6BdwU91__"